import AxiosServices from "./AxiosService";

const Auth = new AxiosServices();


class VouchersService {

    AddVouchers = async (vouchers) => {
        return Auth.post('/vouchers', vouchers)
    };

    GetById(voucherId) {
        return Auth.get(`/vouchers/${voucherId}`)
    }
    UpdateByID(vouchers, voucherId){
        return Auth.put(`/vouchers/${voucherId}`, vouchers)
    }

    DeleteById(voucherId) {
        return Auth.delete(`/vouchers/${voucherId}`)
    }

    validateVoucher(vouchers) {
        return Auth.post('/vouchers/validate', vouchers);
    }

    GetAllVouchers(code = "", product_type = "", active = "") {
        const queryParams = new URLSearchParams();
        if (code) queryParams.append('code', code);
        if (product_type) queryParams.append('product_type', product_type);
        if (active) queryParams.append('active', active);

        return Auth.get(`/vouchers${queryParams.toString() ? `?${queryParams.toString()}` : ''}`);
    }

}

export default VouchersService

